import moment from 'moment'
import getFormattedOffset from '@utils/format-date-timezone-offset'

export default class SystemTest {
  constructor(onTest = false, effectiveDate = '', expireDate = '') {
    this.onTest = onTest
    this.localEffectiveDate = effectiveDate
    this.localExpireDate = expireDate
    this.storedEffectiveDate = effectiveDate
    this.storedExpireDate = expireDate
  }

  mapFromApi(responseData, timeZoneInfo) {
    this.onTest = responseData.OnTest

    if (responseData.EffectiveDate) {
      this.storedEffectiveDate = responseData.EffectiveDate
      this.localEffectiveDate = moment(
        responseData.EffectiveDate + getFormattedOffset(timeZoneInfo)
      ).utc()
    }

    if (responseData.ExpireDate) {
      this.storedExpireDate = responseData.ExpireDate
      this.localExpireDate = moment(
        responseData.ExpireDate + getFormattedOffset(timeZoneInfo)
      ).utc()
    }
  }
}
